import { render, staticRenderFns } from "./BlogFooterCta.vue?vue&type=template&id=2045258e&scoped=true&"
import script from "./BlogFooterCta.vue?vue&type=script&lang=js&"
export * from "./BlogFooterCta.vue?vue&type=script&lang=js&"
import style0 from "./BlogFooterCta.vue?vue&type=style&index=0&id=2045258e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045258e",
  null
  
)

export default component.exports